/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Module, $) {
	'use strict';
	/*globals Tc, SCS, scsHeader */

	/**
	 * Personalization Container
	 *
	 * @author Dave Talamona (tzhtada2)
	 * @namespace Tc.Module
	 * @class PersonalizationContainer
	 * @extends Tc.Module
	 */

	Module.PersonalizationContainer = Module.extend({

		conditions: [], // array of strings with keys for personalization-checks
		conditionIndex: -1,

		/**
		 * Init (called onDomReady)
		 *
		 * @method on
		 * @param {Function} callback function
		 * @return void
		 */
		on: function (callback) {
			var mod = this;

			// break in author / edit mode
			if ($('body').hasClass('cq_isEditMode')) {
				callback();
				return;
			}

			mod.conditions = mod.$ctx.data('conditions').substr(1, mod.$ctx.data('conditions').length - 2).split(',');
			mod.checkNextCondition();

			callback();
		},

		checkNextCondition: function (result) {
			var mod = this;

			mod.conditionIndex++;

			// condition failed? -> show normal content, not personalized one
			if (result === false) {
				mod.$ctx.addClass('normal');
				SCS.utils.initNewModules(mod.$ctx.children('.normal'));
			}

			// all conditions checked and none failed? -> show personalized content, not normal one
			else if (mod.conditionIndex >= mod.conditions.length) {
				mod.$ctx.addClass('personalized');
				SCS.utils.initNewModules(mod.$ctx.children('.personalized'));
			}

			// check next condition
			else {
				mod['condition_' + $.trim(mod.conditions[mod.conditionIndex])]($.proxy(mod.checkNextCondition, mod));
			}
		},


		/**
		 * -------------------------------------------------------------------------------------------------------------
		 * INSERT CONDITION-CHECKING FUNCTIONS HERE
		 * follow the naming-convention "condition_XXX" where "XXX" ist the name of the condition in the data attribute
		 * -------------------------------------------------------------------------------------------------------------
		 */

		// is user logged in or not?
		condition_loggedIn: function (callback) {
			require('lib/personalization/profile').getProfile().then(function(profile) {
				callback(!!profile.getUser());
			});
		},

		// user has items in quickbasket?
		condition_quickbasketHasItems: function (callback) {
			SCS.utils.ajaxCache.getJSON(this.$ctx.data('quickbasket-list-url') + '?session_lang=' + $('html').attr('lang'), function (json) {
				var hasItems = !!(json && json.quickBaskets && json.quickBaskets.length);

				// tracking
				if (hasItems) {
					var siteCatalyst = window.s || window.s_one;
					if(siteCatalyst) {
						SCS.portal.datalayer.trackEvent('view', 'quickbasket', siteCatalyst.pageName, 'quickbasket', 'Quickbasket View');
					}
				}

				callback(hasItems);
			});
		}
	});

})(Tc.Module, Tc.$);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.PersonalizationContainer.js
// module id = 158
// module chunks = 0